import {ReactNode} from 'react';

interface ReviewCardProps {
  title: string;
  children: ReactNode;
  onEdit?: () => void;
  variant?: 'default' | 'detail';
}

export const ReviewCard = ({
  title,
  children,
  onEdit,
  variant = 'default',
}: ReviewCardProps) => (
  <section className="overflow-hidden rounded-[10px] border border-borderLight bg-white">
    <header
      className={`flex items-center justify-between border-b border-borderLight ${
        variant === 'detail'
          ? 'bg-white px-4 py-4'
          : 'bg-backgroundLight px-6 py-5'
      }`}>
      <h2 className="text-base font-semibold leading-6 text-blackTwo">
        {title}
      </h2>
      {onEdit && (
        <button
          type="button"
          aria-label={`Edit ${title}`}
          onClick={onEdit}
          className="rounded-lg border border-borderDark bg-white px-4 py-2 text-sm font-semibold leading-[22px] text-blackTwo transition-colors hover:bg-backgroundLight focus:outline-none focus:ring-2 focus:ring-purple200">
          Edit
        </button>
      )}
    </header>
    <div className={variant === 'detail' ? 'p-4' : 'p-6'}>{children}</div>
  </section>
);
